export default __webpack_public_path__ + "a4cb012a11724c88f24ebcaccda6a9d2.png";